import React from 'react';
import { Checkbox, Input, Tooltip, Row, Col, Form } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const ServicesSectionMobile = ({
  isTransportationChecked,
  isAssemblyDismantleChecked,
  isEndorsementChecked,
  siteAddress,
  onTransportationChange,
  onAssemblyDismantleChange,
  onEndorsementChange,
  onSiteAddressChange
}) => {
  return (
    <>
      <Form.Item
        label="Select service details:"
        style={{ marginBottom: '10px', width: '100%', marginTop: '-10px' }}
      >
        <div style={{
          border: '1px dashed #a1a1a1', 
          borderRadius: '6px',
          padding: '15px',
          marginBottom: '10px'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Checkbox
              checked={isTransportationChecked}
              onChange={onTransportationChange}
              style={{ 
                color: 'white',
                display: 'flex',
                alignItems: 'flex-start'
              }}
            >
              <span style={{ marginLeft: '8px' }}>Delivery and Collection (Transportation)</span>
            </Checkbox>
            
            <Tooltip 
              title={!isTransportationChecked ? "Select transportation first" : ""}
              placement="top"
            >
              <Checkbox
                checked={isAssemblyDismantleChecked}
                onChange={onAssemblyDismantleChange}
                disabled={!isTransportationChecked}
                style={{ 
                  color: 'white',
                  display: 'flex',
                  alignItems: 'flex-start'
                }}
              >
                <span style={{ marginLeft: '8px' }}>Assemble and Dismantle</span>
              </Checkbox>
            </Tooltip>
            
            <Checkbox
              checked={isEndorsementChecked}
              onChange={onEndorsementChange}
              style={{ 
                color: 'white',
                display: 'flex',
                alignItems: 'flex-start'
              }}
            >
              <span style={{ marginLeft: '8px' }}>
                Endorsement (Weekly)
                <Tooltip 
                  title="Endorsement is free for the first week. Subsequent weeks will be charged."
                  placement="top"
                >
                  <InfoCircleOutlined 
                    style={{ 
                      marginLeft: '8px', 
                      color: '#1890ff',
                      cursor: 'help'
                    }} 
                  />
                </Tooltip>
              </span>
            </Checkbox>
            
            {isTransportationChecked && (
              <Input
                placeholder="Site Address"
                value={siteAddress}
                onChange={onSiteAddressChange}
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: '#434343',
                  color: 'white',
                  width: '100%',
                  marginTop: '8px'
                }}
              />
            )}
          </div>
        </div>
      </Form.Item>
    </>
  );
};

export default ServicesSectionMobile;
